"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("@atlaskit/theme");
const colors = __importStar(require("@atlaskit/theme/colors"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const styled_1 = require("../styled");
const Toggle = require("@atlaskit/toggle").default;
const CardDiv = styled_components_1.default.div;
const boxShadow = "0 3px 0 0 rgba(0, 0, 0, 0.05), 0 0 0 2px rgba(0, 0, 0, 0.03)";
exports.CardContainer = CardDiv `
    position: relative;
    padding: 10px;
    margin: 10px;
    border-radius: 2px;
    box-shadow: ${boxShadow};
    background-color: ${props => props.enabled
    ? theme_1.themed({ light: colors.N0, dark: colors.DN50 })(props)
    : theme_1.themed({ light: colors.N30, dark: colors.DN70 })(props)};
    transition: background-color 140ms ease-in-out;
    ${props => props.editMode
    ? `&:focus {
        box-shadow: 0 0 0 2px ${colors.B100};
        outline: none;
    }
    &:hover {
        box-shadow: ${boxShadow};
        background-color: ${theme_1.themed({ light: colors.N30, dark: colors.DN70 })(props)};
    }
    &:active {
        box-shadow: ${boxShadow};
        background-color: ${colors.B50};
    }`
    : ""}
`;
const CardTitle = styled_components_1.default.h3 `
  margin-top: 0px;
  margin-bottom: 20px;
`;
exports.withWidgetControls = (title) => (WrappedComponent) => {
    class WithWidgetControls extends React.Component {
        render() {
            const { widgetProps: { id, editMode, index, enabled, setEnabled } } = this.props;
            return enabled || editMode ? (React.createElement(react_beautiful_dnd_1.Draggable, { draggableId: id, index: index, isDragDisabled: !editMode }, (provided) => {
                const draggableProps = provided.draggableProps;
                return (React.createElement("div", null,
                    React.createElement("div", Object.assign({ ref: provided.innerRef }, draggableProps, provided.dragHandleProps),
                        React.createElement(exports.CardContainer, { editMode: editMode, enabled: enabled },
                            editMode ? (React.createElement(styled_1.RightDiv, { className: "right" },
                                React.createElement(Toggle, { isDefaultChecked: enabled, onChange: () => setEnabled(!enabled) }))) : null,
                            React.createElement(CardTitle, { className: "ppage-title" }, title),
                            React.createElement(WrappedComponent, Object.assign({}, this.props)))),
                    provided.placeholder));
            })) : null;
        }
    }
    WithWidgetControls.WrappedComponent = WrappedComponent;
    exports.withWidgetControls.WrappedComponent = WithWidgetControls;
    return WithWidgetControls;
};
